import { z } from '@repo/schema'
import { getDataWrapperSchema } from '@repo/schema/data-wrapper'
import { UpFetch } from '@repo/upfetch'

import { createProcedure } from '../../lib/procedure.ts'

export const createPermissionsRoute = (upFetch: UpFetch) => {
  const p = createProcedure(upFetch)

  return {
    list: p.path('permissions').query(({ path, upFetch }) =>
      upFetch(path, {
        schema: getDataWrapperSchema(
          z
            .object({
              description: z.string().nullish(),
              name: z.string(),
            })
            .array(),
        ),
      }),
    ),
  }
}
